var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rules-table',{attrs:{"headers":_vm.headers,"rtb_standards":_vm.rtb_standards},on:{"getRtbId":function($event){return _vm.rtbRuleDelete($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }